const ORGANIZATION_LOCALE_EVENT = {
  UPDATE: 'UpdateOrganizationLocale',
};

export {ORGANIZATION_LOCALE_EVENT};
